import { getDefaultPearsonEulaUrl, resolveTermsPolicyUrl } from '@/utils/pearsonEulaUrl';

const cache = new Map();

export async function getConsentPolicyByClientId (clientId, locale = null) {
    const CONSENTS = {
        TERMS: getDefaultPearsonEulaUrl(),
        PRIVACY_POLICY: 'https://www.pearson.com/privacy-center/privacy-notices.html'
    };

    if (!clientId) {
        console.log('no client id passed.');
        return CONSENTS;
    };

    const cacheKey = `${clientId}:${locale || ''}`;
    if (cache.has(cacheKey)) {
        return cache.get(cacheKey);
    }

    const CATEGORY_MAPPING = {
        'terms of use': 'TERMS',
        'privacy policy': 'PRIVACY_POLICY'
    };

    try {
        const headers = new Headers();
        headers.append('x-openidm-username', 'anonymous');
        headers.append('x-openidm-password', 'anonymous');

        const response = await fetch(
            `/openidm/endpoint/consentpolicy?action=get&clientID=${clientId}`,
            {
                method: 'GET',
                headers: headers
            }
        );

        if (!response.ok) {
            console.log('response is not ok', response, CONSENTS);
            return CONSENTS;
        };

        const data = await response.json();

        for (const policy of data.policyDetails) {
            const category = policy.category.toLowerCase();
            if (category in CATEGORY_MAPPING) {
                CONSENTS[CATEGORY_MAPPING[category]] =
                    category === 'terms of use'
                        ? resolveTermsPolicyUrl(policy, locale)
                        : policy.policyRef;
            };
        };
        cache.set(cacheKey, CONSENTS);
        return CONSENTS;
    } catch (error) {
        console.log(error);
        return CONSENTS;
    }
};
